<template>
  <el-dialog
      title="字典管理"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
      width="50%"
      >
    <div class="addDicVal">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" inline>
        <el-form-item label="字典值" prop="dictValue">
          <el-input v-model.trim="ruleForm.dictValue" placeholder="请输入字典值" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="字典值说明" prop="description">
          <el-input v-model.trim="ruleForm.description" placeholder="请输入字典值说明" maxlength="30"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addValue">添加</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="plain" @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>

      <new-table :data="tableData" :columns="columns" :pages="pages"/>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import newTable from "@/components/new-table"

export default {
  data() {
    return {
      // 内置字典值代码数组(禁止删除、修改)
      dicValCodeList: [
        // 客户跟进状态
        'FollowUpState_Stay',
        'FollowUpState_FU',
        'FollowUpState_End',
        // 客户来源
        'FormSource_ZJS',
        'FormSource_XSBJ',
        'FormSource_GG',
        'FormSource_DHLX',
        // 客户等级
        'Level_A',
        'Level_B',
        'Level_Vip',
        // 操作类型
        'OperateType_CreateCustomer',
        'OperateType_AllotCustomer',
        'OperateType_ReceiveCustomer',
        'OperateType_ReturnCommon',
        'OperateType_ImportCustomer',
        // 客户跟进方式
        'FollowupMethod_phone',
        'FollowupMethod_visit',
        'FollowupMethod_chat',
        'FollowupMethod_emil',
      ],
      tempRow: '',
      dialogVisible: false,
      ruleForm: {
        dictId: '',
        dictValue: '',
        description: '',
      },
      rules:{
        dictValue: [
          { required: true, message: '请输入字典值', trigger: 'change' },
        ],
        description: [
          { required: true, message: '请输入字典值说明', trigger: 'change' },
        ],
      },
      tableData: [],
      columns: [
        {label: "字典值",
          render: (h,{row}) => {
            if( row.isEdit ) {
              return <div>
                <el-input v-model={ row.dictValue } maxlength="30" style="width: 200px"></el-input>
              </div>
            } else {
              return row.dictValue;
            }
          }
        },
        {label: "字典值说明",
          render: (h,{row}) => {
            if( row.isEdit ) {
              return <div>
                <el-input v-model={ row.description } maxlength="30" style="width: 200px"></el-input>
              </div>
            } else {
              return row.description;
            }
          }
        },
        { label: "操作",
          render: ( h,{row} ) => {
            if( !row.isEdit ) {
              return <div>
                { !row.isSystem?
                    <div>
                      <el-button type="text" onClick={() => this.edit(row)}>编辑</el-button>
                      <el-button type="text" style="color: #fa5d5f" onClick={() => this.delValue(row.id)}>删除</el-button>
                    </div>
                    :'' }
              </div>
            } else {
              return <div>
                <el-button type="text" onClick={() => this.sureSave(row)}>保存</el-button>
                <el-button type="text" style="color: #fa5d5f" onClick={() => this.cancelEdit(row)}>取消</el-button>
              </div>
            }
          }
        }
      ],
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change":(p) => {
            this.sizesChange(p)
          }
        },
      },
      dictId: '',
    }
  },
  methods: {
    open(dictId) {
      this.dictId = dictId;
      this.dialogVisible = true;
      this.tempRow = '';
      this.ruleForm = {
        dictId: this.dictId,
        dictValue: '',
        description: '',
      }
      this.getList();
    },
    getList() {
      this.$axios.get(`/Crm/Dictionary/DicValuePageListByDic?pageIndex=${ this.pages.props["current-page"]
      }&pageSize=${ this.pages.props["page-size"]
      }&dicId=${ this.dictId
      }`).then(res => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      })
    },
    addValue() {
      this.$refs.ruleForm.validate((valid) =>{
        if(valid) {
          this.$axios.post(`/Crm/Dictionary/AddDictionaryValue`,this.ruleForm).then(() => {
            this.$message.success(`添加成功`);
            this.resetForm('ruleForm');
            this.getList();
          })
        }
      })
    },
    delValue(id) {
      this.$confirm("确定要删除该字典值吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios.delete(`/Crm/Dictionary/DictionaryValueById?valId=${ id }`).then(() => {
          this.$message.success(`删除成功`);
          this.tableData.length == 1 && this.pages.props["current-page"] != 1 && (this.pages.props["current-page"] -= 1);
          this.getList();
        })
      }).catch(() => {});
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    edit(row) {
      // 让表格最多只有一行是编辑状态
      this.tempRow && this.cancelEdit(this.tempRow);
      this.tempRow = row;

      this.$set(row,'isEdit',true);
      this.$set(row,'tempName',row.name);
      this.$set(row,'tempDate',row.date);
    },
    sureSave(row) {
      this.$axios.post(`/Crm/Dictionary/ModifyDictionaryValue`,row).then(() => {
        this.$message.success(`修改成功！`);
        this.getList();
      })
    },
    cancelEdit(row) {
      this.$set(row,'isEdit',false);
      this.$set(row,'name',row.tempName);
      this.$set(row,'date',row.tempDate);
    },
    currentChange(p) {
      this.pages.props['current-page'] = p;
      this.getList();
    },
    sizesChange(s) {
      this.pages.props["current-page"] = 1;
      this.pages.props["page-size"] = s;
      this.getList();
    },
  },
  components: {
    newTable
  }
}
</script>

<style scoped lang="scss">
  .addDicVal {
    ::v-deep .el-table__body-wrapper {
      min-height: 200px;
      max-height: 320px;
      height: auto!important;
      display: flex;
      flex-direction: column;
      .el-table__empty-block {
        flex: 1;
      }
    }
  }
</style>